import { DefaultTheme } from "styled-components";
import logoAqmed from "./logo.png";
import backgroundAqmed from "./background.png";

export const aqmedTheme: DefaultTheme = {
  title: "aqmed",

  colors: {
    primary: "#159945",
    secondary: "#5f1ba1",
    chatMessage: "#5f1ba1",
  },

  images: {
    logo: logoAqmed,
    background: backgroundAqmed,
  },
};
